<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <rewards-table></rewards-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import RewardsTable from './RewardsTable.vue'

  export default {
    name: 'scratchcard-rewards',
    components: {RewardsTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/scratchcard/rewards/Rewards.vue